<script>
    import { FirebaseApp, Doc, Collection } from 'sveltefire';
</script>

<Doc let:traceId path={'pages/contribute'} let:ref let:data={data} let:error>
    {#if data.note != ''}
    <div class="full-width notice">
        <p>{@html data.note}</p>
    </div>
    {/if}

    <div slot="fallback">
        <div class="full-width notice">
            <p><strong>oh god oh fuck.</strong> Something went wrong, you're not supposed to see this.</p>
        </div>
    </div>
</Doc>

<h2>Contribute</h2>
<sup>StadiaDB is developed and maintained by <a href="https://jediburrell.com">Jedi Burrell</a>.</sup>
<h3>Contributing Prices</h3>
<p>Thanks to Stadia's public release, I'm now able to get the prices for all countries.<br />
 Thank you so much to the people who've submitted screenshots!
<h3>Donating</h3>
<p>You can still donate to help the upkeep of the site through the <a href="https://cash.me/$JediBurrell">Cash App</a> or with Bitcoin.</p>
<sup>Bitcoin Address: 1Em8NdA1ne4Pp2ForaoK1F98TMnNuTouwK</sup>
<br />
<h3>Contributors</h3>
<p>Alexandre Paradis — Canada Prices</p>
<p>Brian Aiya — Canada Prices</p>
<p>Jeremy Banks — Canada Prices</p>
<p>Andreas Treskatsch — Germany Prices</p>
<p>Erik Böge — Germany Prices</p>
<p>Elia Giorgi — Italy Prices</p>
<p>Nathanaël Philipse — Netherlands Prices</p>
<p>Brian Davis — Pro Prices (US)</p>
<p>Darren Hardy — UK Prices</p>
<p>James Waghorn — UK Prices</p>
<p>Knowbeard — UK Prices</p>
<br />

<style>
    .notice {
        background: #eeeeee;
        padding: 10px;
        padding-left: 5vw;
        padding-right: 5vw;
        width: 90vw;
    }

    :global(main.dark) .notice {
        background: #212121;
    }
</style>